import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["presenceStatus"]

  connect() {
    this.startHeartbeat()
  }

  disconnect() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
    }
  }

  startHeartbeat() {
    // Send initial heartbeat immediately
    this.sendHeartbeat()

    // Update active status every 3 minutes
    this.heartbeatTimer = setInterval(() => {
      this.sendHeartbeat()
    }, 3 * 60 * 1000)
  }

  sendHeartbeat() {
    fetch("/status_update", {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ status: "online" })
    }).catch(err => console.warn("[Heartbeat] Failed:", err))
  }
}

